<template>
  <div>
    <b-modal id="modalEditAvailReports" ref="modalEditAvailReports" @shown="shown"
      :title="$t('Customer reports')" hide-footer>
      <div  v-if="editItem">
        <b-form-group label-align="right" v-if="editItem.id != 0" disabled label="ID" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input v-model="editItem.id" disabled/>
        </b-form-group>
        <b-form-group label-align="right" :disabled="editItem.id != 0" :label="$t('Group')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-select v-model="editItem.group_id" :options="groups" :disabled="editItem.id != 0"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Active')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-checkbox switch size="lg" v-model="editItem.is_enabled" value="1" unchecked-value="0" />
        </b-form-group>
        <b-form-group :label="$t('Allowed reports')">
        <b-form-checkbox-group
            v-model="editItem.reports"
            :options="optionsReports"
            switches
        ></b-form-checkbox-group>
        </b-form-group>

        <modal-ok-cancel @save="save" @cancel="$bvModal.hide('modalEditAvailReports')" size="md"/>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    editItem: null
  },
  data () {
    return {
      optionsReports: [
        {text: this.$i18n.t('Full statistics'), value: 1},
        {text: this.$i18n.t('Blocking'), value: 2},
        {text: this.$i18n.t('Sessions'), value: 4},
        {text: this.$i18n.t('Traffic'), value: 8},
        {text: this.$i18n.t('Telephony report'), value: 16},
        {text: this.$i18n.t('Notifications'), value: 32}
      ]
    }
  },
  methods: {
    save () {
      this.editItem.available_reports = 0
      this.editItem.reports.forEach(element => { this.editItem.available_reports += element })
      delete (this.editItem.reports)
      let response = this.$store.dispatch('Settings/UPDATE_AVAIL_REPORTS_SETTINGS', this.editItem)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_AVAIL_REPORTS_SETTINGS')
          this.$bvModal.hide('modalEditAvailReports')
          this.$root.$emit('makeToasts')
        }
      })
    },
    shown () {
      if (this.editItem.id === 0 && this.groups.length) {
        this.editItem.group_id = this.groups[0].value
      }
    }
  },
  computed: {
    groups () {
      let res = []
      res.push({value: 0, text: 'All'})
      for (let el of this.$store.getters['Users/GROUPS']) {
        let newEl = {}
        newEl.value = el.group_id
        newEl.text = el.group_name
        res.push(newEl)
      }
      return res
    }
  },
  mounted () {
    if (this.editItem) {
      this.selectedReports = this.editItem
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/customerPortal/reports/editModal.vue